import React, { Component } from 'react'
import CollapsibleTile from '../../../components/CollapsibleTile';
import GenericTable from '../../../components/GenericTable/GenericTable';
import { APIData } from '../../../constants/APIAdresses';
import { MUI_COLORS } from '../../../constants/MUIConstants';
import PromoCodeDialog from './PromoCodeDialog/PromoCodeDialog';
import { getCategoriesByIdList, getProductsByIdList, getPromoByIdList, getPromoCodeById, setPromoCodeActiveStatus } from '../../../APIHelper';
import { ALERT_SEVERITY } from '../../../components/AlertDisplay2';
import CustomLightButton from '../../../components/CustomLightButton';
import PromoLedgerDialog from './PromoCodeDialog/PromoLedgerDialog';
import ShareCodeDialog from './PromoCodeDialog/ShareCodeDialog';

const promoColumns = [
    // {
    //     width: 150,
    //     label: 'ID',
    //     // baseImgUri: APIData.MEDIA,
    //     dataKey: 'ID',
    // },
    {
        width: 50,
        label: 'ID',
        dataKey: 'id',
    },
    {
        // width: 2,
        label: 'Code',
        dataKey: 'code',
    },
    {
        label: 'Öffentliche Beschreibung',
        dataKey: 'publicDescription'
    },
    {
        label: 'Private Beschreibung',
        dataKey: 'internalDescription'
    },
    {
        // width:2,
        label: 'Prozent-Rabatt',
        dataKey: 'percent',
        format: (value) => { return value != null ? value.replace(".", ",") + " %" : "-" }
    },
    {
        // width:2,
        label: 'Fix-Rabatt',
        dataKey: 'fixed',
        format: (value) => { return value != null ? value.replace(".", ",") + " €" : "-" }
    },
]
export class PromocodeTile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            promoCodes: [],
            // dialogOpen: false,
            dialogOpen: false,
            ledgerDialogOpen: false,
            shareDialogOpen: false,
            editMode: false,
            // promoCodeEditModeData: { id: "124512" },
            promoCodeEditModeData: null,
        }
        this.editDataLoading = false;
    }
    deletePromocode(index) { }

    async onEdit(id) {
        if (this.editDataLoading) return;
        this.setState({ loading: true });
        const fullData = await getPromoCodeById(id);
        console.log("Full data for promocode edit: ", fullData);
        let catIds = Array.isArray(fullData.categoryConfigs) ? fullData.categoryConfigs.map(c => c.id) : [] // we need name info for those categories
        let productIds = Array.isArray(fullData.productConfigs) ? fullData.productConfigs.map(p => p.id) : [] // we need name info for those products
        let promoCodeIds = fullData.combineRestrictedIds;
        console.log("########### catIds: ", catIds, " catconfigs: ", fullData.categoryConfigs);
        console.log("########### productIds: ", productIds, " productConfigs: ", fullData.productConfigs);
        console.log("########### promoCodeIds: ", promoCodeIds, " combineRestrictedIds: ", fullData.combineRestrictedIds);
        if (catIds.length > 0) {
            const catResult = await getCategoriesByIdList(catIds);
            if (catResult != null) {
                fullData.categoryConfigs.forEach(cat => {
                    const matchedCat = catResult.find(c => c.id.toString() === cat.id.toString());
                    if (matchedCat) {
                        cat.name = matchedCat.name;
                    }
                });
            }
        }
        if (productIds.length > 0) {
            const prodResult = await getProductsByIdList(productIds);
            if (prodResult != null) {
                fullData.productConfigs.forEach(prod => {
                    const matchedProd = prodResult.find(p => p.id.toString() === prod.id.toString());
                    if (matchedProd) {
                        prod.name = matchedProd.name;
                    }
                });
            }
        }
        if (promoCodeIds.length > 0) {
            const res = await getPromoByIdList(promoCodeIds);
            if (res != null) {
                fullData.combineRestrictedCodes = res;
            }
        }
        this.setState({ promoCodeEditModeData: fullData, editMode: true, dialogOpen: true, loading: false });
    }
    async toggleActive(index) {
        try {
            const promo = this.state.promoCodes[index];
            const promoId = promo?.id;
            if (promoId == null) {
                console.error("Promo ID is null, cannot toggle active status.");
                return;
            }
            const res = await setPromoCodeActiveStatus(promoId, promo.isActive ? false : true);
            if (res != null) {
                const myData = [...this.state.promoCodes];
                myData[index] = { ...myData[index], isActive: !myData[index].isActive };
                this.setState({ promoCodes: myData });
                this.props.showAlert(`Aktionscode '${promo.code}' wurde erfolgreich ${promo.isActive ? 'deaktiviert' : 'aktiviert'}.`, ALERT_SEVERITY.SUCCESS);
            } else {
                this.props.showAlert(`Fehler beim ${promo.isActive ? 'deaktivieren' : 'aktivieren'} des Aktionscodes '${promo.code}'.`, ALERT_SEVERITY.ERROR);
            }
        } catch (error) {
            console.error("Error while toggling active status: ", error);
            this.props.showAlert(`Fehler beim ${this.state.promoCodes[index]?.isActive ? 'deaktivieren' : 'aktivieren'} des Aktionscodes '${this.state.promoCodes[index]?.name}'.`, ALERT_SEVERITY.ERROR);
        }
    }
    render() {
        const { shopId, companyId } = this.props;
        return (
            <CollapsibleTile title="Aktioncodes"
                isLoading={this.state.loading}
                onCollapseChange={(isExpanded, firstExpand) => {
                    console.log("ONCOLLAPSE???")
                    if (isExpanded && firstExpand) {
                        // this.loadOpeningHours();
                    }
                }}
                icon={<img src={require('../../../assets/icons/voucher.png')} width={20} height={20} />}>
                <div style={{ display: "flex", flexDirection: "column", gap: 15 }}>


                    <GenericTable
                        activeKey="isActive"
                        addBtnLabel="Aktionscode hinzufügen"
                        addBtnOnClick={() => {
                            this.setState({ promoCodeEditModeData: null, editMode: false, dialogOpen: true });
                            // this.setState({ promoCodeEditModeData: null, }, () => {
                            //     // the promoCodeEditModeData is being processed in the PromoCodeDialogs componentDidMount
                            //     // And this callback is just for making sure, that the state of promoCodeEditModeData is accidentally null
                            //     this.setState({ dialogOpen: true, editMode: false });
                            // }) 
                        }}
                        apiEndPoint={APIData.SHOP + `/promocode/getAll?shopId=${shopId}`}
                        tableData={this.state.promoCodes}
                        setTableData={(data) => { this.setState({ promoCodes: data }) }}
                        onClickRow={(index) => {
                            this.setState({ selectedProductIndex: index })
                        }}
                        config={{ columns: promoColumns }}
                        onEdit={(index, id) => {
                            this.onEdit(this.state.promoCodes[index].id);
                            // this.setState({ selectedProductIndex: index })
                        }}
                        // onDuplicate={(index, id) => {
                        //     this.duplicateProduct(index, id);
                        // }}
                        // onDelete={(index, id) => {
                        //     this.props.openAlertDialog(
                        //         [
                        //             {
                        //                 label: "Ja",
                        //                 color: MUI_COLORS.ERROR,
                        //                 onChoice: () => {
                        //                     this.deletePromocode(index);
                        //                 }
                        //             },
                        //             {
                        //                 label: "Nein",
                        //                 onChoice: () => {
                        //                     console.log("Aktionscode wird nicht gelöscht...");
                        //                 }
                        //             }
                        //         ],
                        //         "Löschen", "Möchtest du den Aktionscode '" + this.state.promoCodes[index].name + "' wirklich löschen? Alternativ kannst du ihn auch deaktivieren, dadurch wird er nicht mehr im Shop angezeigt, aber bleibt in der Datenbank erhalten."
                        //     )
                        // }}
                        onSetActive={(index, active) => {
                            // this.setProductActive(index);
                            this.toggleActive(index);
                        }}
                    />
                    <div style={{ display: "flex", gap: 10 }}>
                        <CustomLightButton
                            style={{ minWidth: 150, flex: 1 }}
                            label="Historie Ansehen"
                            icon={require('../../../assets/icons/ledger.png')}
                            onPress={() => {
                                this.setState({ ledgerDialogOpen: true })
                            }}
                        />
                        <CustomLightButton
                            style={{ minWidth: 150, flex: 1 }}
                            label="📤  Teilen"
                            onPress={() => {
                                this.setState({ shareDialogOpen: true })
                            }}
                        />
                    </div>
                </div>
                {this.state.dialogOpen && (
                    <PromoCodeDialog shopId={shopId} companyId={companyId} open={this.state.dialogOpen} title={`Aktionscode ${this.state.editMode ? 'bearbeiten' : 'erstellen'}`}
                        onClose={() => {
                            this.setState({ dialogOpen: false })
                        }} editMode={this.state.editMode}
                        showAlert={(msg, severity) => { this.props.showAlert(msg, severity) }} promoCodeEditModeData={this.state.promoCodeEditModeData}
                    />
                )}
                {this.state.ledgerDialogOpen && (
                    <PromoLedgerDialog shopId={shopId} companyId={companyId} open={this.state.ledgerDialogOpen} title={`Historie`} onClose={() => { this.setState({ ledgerDialogOpen: false }) }} showAlert={(msg, severity) => { this.props.showAlert(msg, severity) }} />
                )}
                {this.state.shareDialogOpen && (
                    <ShareCodeDialog shopId={shopId} companyId={companyId} open={this.state.shareDialogOpen} title={`Aktionscode Teilen`} onClose={() => { this.setState({ shareDialogOpen: false }) }} showAlert={(msg, severity) => { this.props.showAlert(msg, severity) }} />
                )}
            </CollapsibleTile>
        )
    }
}

export default PromocodeTile